import { qwanyxCollection } from 'qwanyx'

export async function getCards(stackId, recursive = true) {
    try {
        const collection = qwanyxCollection();
        const allCards = [];
        const processedIds = new Set();

        async function fetchCardsRecursive(currentStackId) {
            if (processedIds.has(currentStackId)) return;
            processedIds.add(currentStackId);

            const query = { ed: currentStackId };
            const cards = await collection
                .find(query, { 
                    projection: { 
                        _id: 1,
                        di: 1,
                        ed: 1,
                        pa: 1,
                        amount: 1,
                        invoicetype: 1,
                        timestamp: 1,
                        qwantaType: 1
                    } 
                });

            allCards.push(...cards);

            if (recursive) {
                for (const card of cards) {
                    await fetchCardsRecursive(card._id);
                }
            }
        }

        await fetchCardsRecursive(stackId);
        return allCards;

    } catch (error) {
        console.error("Error fetching cards from Qwantas:", error);
        throw error;
    }
}